import React, { Component } from "react";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <section id="footer" className="mm-footer-legal" style={{ padding: 0 }}>
        <div className="row">
          <div className="col-12">
            <div
              className="mm-logo"
              role="img"
              aria-label="MassMutual Logo"
            ></div>
          </div>
          <div className="col-12">
            <p>
              &copy;{new Date().getFullYear()} Massachusetts Mutual Life
              Insurance Company (MassMutual&reg;), Springfield, MA 01111-0001.
              All rights reserved.
            </p>
          </div>
          <div className="col-12">
            <ul>
              <li className="list-inline-item" id="footer-link-terms">
                <a
                  target="_blank"
                  href="https://www.massmutual.com/legal/terms-of-use"
                  rel="noopener noreferrer"
                >
                  Terms of Use
                </a>
              </li>
              <li
                className="list-inline-item"
                id="footer-link-consumer-notification-rights"
              >
                <a
                  target="_blank"
                  href={window.REACT_APP_CONSUMER_AND_NOTIFICATION_RIGHTS_URL}
                  rel="noopener noreferrer"
                  id="cnsm-ntf-rg"
                >
                  Consumer Notification and Rights
                </a>
              </li>
              <li className="list-inline-item" id="footer-link-privacy">
                <a
                  target="_blank"
                  href="https://www.massmutual.com/protecting-your-information"
                  rel="noopener noreferrer"
                >
                  Privacy
                </a>
              </li>
              <br />
              <li className="list-inline-item" id="footer-link-california">
                <a
                  target="_blank"
                  href="https://www.massmutual.com/protecting-your-information/privacy-policy/do-not-sell-or-share"
                  rel="noopener noreferrer"
                >
                  California Do Not Sell or Share My Personal Information
                </a>
              </li>
            </ul>
            {/* <p>CRN202305-248940</p> */}
          </div>
        </div>
      </section>
    );
  }
}

export default Footer;
